import {API_URL, authHeaders, jsonHeaders} from "./index";

const NETWORK_ERROR = "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.";

async function safeJson(promise) {
    try {
        const res = await promise;
        return await res.json();
    } catch {
        return {error: NETWORK_ERROR};
    }
}

export function apiGetNews({page = 1, limit = 9, featuredFirst = false} = {}) {
    const params = new URLSearchParams({page, limit, featuredFirst}).toString();
    return safeJson(fetch(`${API_URL}/news?${params}`));
}

export function apiGetNewsArticle(slug) {
    return safeJson(fetch(`${API_URL}/news/${encodeURIComponent(slug)}`));
}

export function apiAdminListNews(status) {
    const query = status ? `?status=${encodeURIComponent(status)}` : "";
    return safeJson(fetch(`${API_URL}/admin/news${query}`, {headers: authHeaders()}));
}

export function apiAdminGetNews(id) {
    return safeJson(fetch(`${API_URL}/admin/news/${id}`, {headers: authHeaders()}));
}

export function apiAdminCreateNews(payload) {
    return safeJson(fetch(`${API_URL}/admin/news`, {method: "POST", headers: jsonHeaders(), body: JSON.stringify(payload)}));
}

export function apiAdminUpdateNews(id, payload) {
    return safeJson(fetch(`${API_URL}/admin/news/${id}`, {method: "PUT", headers: jsonHeaders(), body: JSON.stringify(payload)}));
}

function adminAction(id, action, method = "POST") {
    return safeJson(fetch(`${API_URL}/admin/news/${id}/${action}`, {method, headers: authHeaders()}));
}

export const apiAdminPublishNews = (id) => adminAction(id, "publish");
export const apiAdminUnpublishNews = (id) => adminAction(id, "unpublish");
export const apiAdminArchiveNews = (id) => adminAction(id, "archive");
export const apiAdminRestoreNews = (id) => adminAction(id, "restore");
export const apiAdminSetFeatured = (id) => adminAction(id, "featured", "PUT");
export const apiAdminUnsetFeatured = (id) => adminAction(id, "featured", "DELETE");

export function apiAdminDeleteNews(id) {
    return safeJson(fetch(`${API_URL}/admin/news/${id}`, {method: "DELETE", headers: authHeaders()}));
}

export function apiUploadNewsImage(file) {
    const formData = new FormData();
    formData.append("image", file);
    return safeJson(fetch(`${API_URL}/admin/news/images`, {method: "POST", headers: authHeaders(), body: formData}));
}

export function apiAdminGenerateNewsDraft(payload) {
    return safeJson(fetch(`${API_URL}/admin/news/ai-draft`, {method: "POST", headers: jsonHeaders(), body: JSON.stringify(payload)}));
}